<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SHss7w/tc-custom/9781597481533.jpg?1677725999139" alt="This image is the cover for the book Paris, Ice Pick, and Petit Fours, Sadie Silver Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Paris, Ice Pick, and Petit Fours, Sadie Silver Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>If you like the Aurora Teagarden Mysteries and Chronicles Mysteries, you'll love the cozy mysteries from Kailin Gow like this one.  It is a Purrfect Mix of Romance, Food, and Mystery. Fashionable Celebrity Pastry Chef Sadie Silver loves mixing travel, food, romance, and crime solving wherever she goes or stays...along with the help of her intelligent cat Orchid and sensitive-smelling-nose dog Biscuit. handsome forensic scientist Palmer, and the mysterious gorgeous man who always places an order directly from her for a dozen red velvet cupcakes.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kailin Gow
      </h2>
      
      <p class="authorDescription body article">Kailin Gow is a million-selling author who has written and published close to 700 books under her name and various pen names in multiple genres since 2001. She is also an award-winning filmmaker whose films has screened all over the world including Cannes, Los Angeles, London, Paris, Japan, Korea, India, Germany, and Greece. Her books Bitter Frost and PULSE Vampires have been made into video games and is currently filming as featured films. She has been named as the most prolific Asian American author, and has been quoted as the representative for AAPI Heritage Week. Currently, two of her book series, Red Genesis, co-written by Kira G. and her science fiction romance series FADE have been optioned by the Netflix Top 2 Overall film production company Wish Dragon. She is set to write and direct the AAPI diverse cast featured film of Jane Austen’s Pride and Prejudice.  As an actress, she is currently in pre-production to star in 4 AAPI-led films, including her enemies-to-lover novel based on her relative’s ramen factory called Ramen Romance and her real-life experience as an author who has organized some of the biggest book signing events in her novel Love Letters from Las Vegas.  Go to KailinGow.com tfor updates and news.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sparklesoup.com
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f556736a